'use client';

import React__default, { useContext, useState, useEffect } from 'react';
import { CascaderContext } from '../../../../context/reducer.js';
import LeftColumnContent from '../LeftColumnContent/index.js';
import RightColumnContent from '../RightColumnContent/index.js';
import { RepsonsiveChildWrapper } from './ResponsiveBody.css.js';

var ResponsiveBody = function () {
    var state = useContext(CascaderContext).state;
    var parentId = state.parentId;
    var _a = useState(false), isMountedLeft = _a[0], setMountedLeft = _a[1];
    var _b = useState(false), isMountedRight = _b[0], setMountedRight = _b[1];
    var onAnimationEnd = function (type) {
        if (type === 'left') {
            if (parentId === -1) {
                return;
            }
            setMountedLeft(false);
        }
        else {
            if (parentId !== -1) {
                return;
            }
            setMountedRight(false);
        }
    };
    useEffect(function () {
        if (parentId === -1) {
            setMountedLeft(true);
        }
        else {
            setMountedRight(true);
        }
    }, [parentId]);
    return (React__default.createElement(React__default.Fragment, null,
        isMountedLeft ? (React__default.createElement(RepsonsiveChildWrapper, { isShow: parentId === -1, side: 'left', onAnimationEnd: function () { return onAnimationEnd('left'); } },
            React__default.createElement(LeftColumnContent, null))) : null,
        isMountedRight ? (React__default.createElement(RepsonsiveChildWrapper, { isShow: parentId !== -1, side: 'right', onAnimationEnd: function () { return onAnimationEnd('right'); } },
            React__default.createElement(RightColumnContent, null))) : null));
};

export { ResponsiveBody as default };
//# sourceMappingURL=index.js.map
